import { color, initials } from '@central/ui';

/** Blue initials tile with the customer's name above "GoATMS Central". */
export function Brand({ customerName }: { customerName: string }) {
  return (
    <>
      <div
        aria-hidden
        style={{
          width: 34,
          height: 34,
          borderRadius: 8,
          background: color.portalMark,
          color: '#FFFFFF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          fontSize: 13,
        }}
      >
        {initials(customerName)}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <span style={{ fontWeight: 700, fontSize: 14 }}>{customerName}</span>
        <span style={{ fontSize: 12, color: color.textMuted }}>GoATMS Central</span>
      </div>
    </>
  );
}
